import useGetPerfil from "features/perfil/hooks/useGetPerfis";

import usePerfilListagemColumns from "./components/usePerfilListagemColumns";
import PerfilEvents from "features/perfil/events";
import { PerfilListItem } from "core/features/perfil/typings";
import useDeletePerfil from "features/perfil/hooks/useDeletePerfil";
import { useBreadcrumb } from "features/breadcrumbs";
import HeaderTable from "components/Page/HeaderTable";
import { useCurrentTenant } from "features/auth/tenant.store";
import PageHeader from "components/Page/PageHeader";
import NewTable from "components/NewTable";
import { useRouteMatch } from "react-router-dom";
import useFilters from "components/Filters/hooks";
import { useHistory } from "react-router-dom";
import { showConfirm } from "infra/helpers/alerta";
import { useLoading } from "components/GlobalLoading";
import { PermissaoEnum } from "core/resources/enums/permissao";
import { checkPermission } from "infra/helpers/permission";
import Container from "components/Container";

function ListagemPerfis() {
  const route = useRouteMatch();
  const { tenant } = useCurrentTenant();
  const history = useHistory();

  const isPerfisEmpresa = route.path.includes("empresa/perfis");
  const tenantId = isPerfisEmpresa ? tenant.tenantPai?.id : tenant.id;

  const { filters, setFilters } = useFilters();

  const { data, isFetching } = useGetPerfil(tenantId, filters);
  const { handleExcluir, isLoadingExcluir } = useDeletePerfil(filters);

  useBreadcrumb(
    !isPerfisEmpresa
      ? [
          { name: "Administração" },
          { name: "Cadastros" },
          { name: "Perfis", url: "/cadastros/perfis" },
        ]
      : [
          { name: "Empresa", url: "/empresa" },
          { name: "Perfis", url: "/empresa/perfis" },
        ]
  );

  const columns = usePerfilListagemColumns();

  useLoading(isLoadingExcluir || isFetching);

  return (
    <Container>
      <PageHeader
        title="Perfil"
        titleButton="Adicionar novo perfil"
        onClick={() => {
          if (
            !checkPermission(
              PermissaoEnum.Backoffice.Administrativo.Perfil.Criar,
              true
            )
          ) {
            return;
          }

          PerfilEvents.iniciarCadastro();

          if (isPerfisEmpresa) {
            history.push("/empresa/perfis/novo");
          } else {
            history.push("/cadastros/perfis/novo");
          }
        }}
      />

      <NewTable<PerfilListItem>
        title={() => (
          <HeaderTable
            value={filters.search as any}
            onSearch={(q?: string) =>
              setFilters({
                ...filters,
                search: q,
                page: 1,
              })
            }
          />
        )}
        onRow={(item) => ({
          style: {
            cursor: "pointer",
          },
          onClick: () => {
            PerfilEvents.verPerfil(item.id);

            if (isPerfisEmpresa) {
              history.push(`/empresa/perfis/${item.id}`);
            } else {
              history.push(`/cadastros/perfis/${item.id}`);
            }
          },
        })}
        actions={[
          {
            title: "Editar",
            permission: PermissaoEnum.Backoffice.Administrativo.Perfil.Editar,
            onClick: (item) => {
              PerfilEvents.iniciarEdicao(item.id);

              if (isPerfisEmpresa) {
                history.push(`/empresa/perfis/${item.id}`);
              } else {
                history.push(`/cadastros/perfis/${item.id}`);
              }
            },
          },
          {
            title: "Excluir",
            permission: PermissaoEnum.Backoffice.Administrativo.Perfil.Excluir,
            shouldRender: (item) => !item.admin,
            onClick: (item) => {
              showConfirm().then(({ isConfirmed }) => {
                if (isConfirmed) {
                  PerfilEvents.excluir(item.id);
                  handleExcluir(item.id);
                } else {
                  PerfilEvents.cancelarExclusao(item.id);
                }
              });
            },
          },
        ]}
        loading={isFetching}
        columns={columns}
        dataSource={data?.items || []}
        customPagination={{
          onChangePage: (page) =>
            setFilters({
              ...filters,
              page,
            }),
          currentPage: data?.meta.currentPage ?? 0,
          itemsPerPage: data?.meta.itemsPerPage ?? 0,
          totalItems: data?.meta.totalItems ?? 0,
        }}
      />
    </Container>
  );
}

export default ListagemPerfis;
